import { Empty, Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useTakenActions } from "../useTakenActions"
import { ActionRow } from "./ActionRow"

import styles from "../TakenActions.module.scss"

export const ActionsSection = ({ issueId }: { issueId?: string }) => {
  const { t } = useTranslation()
  const { actions, remove } = useTakenActions(issueId)

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <Text className={styles.cardTitle}>
          {t("triage.remediation.actions.title")}
        </Text>
      </div>
      <div className={styles.cardBody}>
        {actions.length ? (
          actions.map((action) => (
            <ActionRow
              key={action.id}
              action={action}
              onRemove={() => remove(action.id)}
            />
          ))
        ) : (
          <Empty
            className={styles.empty}
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <Flex vertical gap={2} align="center">
                <Text className={styles.emptyTitle}>
                  {t("triage.remediation.actions.empty.title")}
                </Text>
                <Text className={styles.emptyDescription}>
                  {t("triage.remediation.actions.empty.description")}
                </Text>
              </Flex>
            }
          />
        )}
      </div>
    </div>
  )
}
